import {Application} from "../application/application";

export interface PublisherInterface
{
	// askForAccess(onStatusChange: Function, onDialogCancelled: Function): void;
	// stop(onReady: () => void): void;
	// destroy(onReady: () => void): void;

	init(app?: Application) : Promise<void>;

	getCamList(): string[];
	getMicList(): string[];

	mute(muted: boolean): void;

	showPreview(show: boolean): void;

	publish(streamName: string): Promise<void>;

	unpublish(): Promise<void>;
	destroy() : Promise<void>;

	takeSnapshot (quality: number): string;
}

